import { IProjectsResponse } from "Model/Responses/IProjectsResponse";
import { IProject } from "Model/Storage/IProject";
import { Pool, spawn, Worker } from "threads";
import { ProjectsWorker } from "./Worker";

const pool = Pool(() => spawn<ProjectsWorker>(new Worker(`./projectsWorker.js`)), { size: 1 });

export async function deleteProject(...args: [string, string]): Promise<void> {
  return pool.queue((worker) => worker.deleteProject(...args));
}

export async function getProjects(...args: [string, string, number]): Promise<IProjectsResponse> {
  return pool.queue((worker) => worker.getProjects(...args));
}

export async function getProjectsSince(...args: [string, string]): Promise<IProjectsResponse> {
  return pool.queue((worker) => worker.getProjectsSince(...args));
}

export async function getProjectsById(...args: [string, string[]]): Promise<IProject[]> {
  return pool.queue((worker) => worker.getProjectsById(...args));
}

export async function importStatus(...args: [string]): Promise<boolean> {
  return pool.queue((worker) => worker.importStatus(...args));
}

export async function importProjects(...args: [string]): Promise<void> {
  return pool.queue((worker) => worker.importProjects(...args));
}
export async function updateProjects(...args: [string, IProject[]]): Promise<void> {
  return pool.queue((worker) => worker.updateProjects(...args));
}
